/**
 * @class TableData
 */
export default class TableData {
  tableData={}
  static ins=null;

  /**
   *
   * @returns TableData
   */
  static getInstance(){
    if(!TableData.ins){
      TableData.ins=new TableData();
    }
    return TableData.ins;
  }
  setList(key,list){
    if(list&&list.length>0){
      this.tableData[key]=list;
    }else {
      delete this.tableData[key];
    }
  }
  getList(key){
    return this.tableData[key];
  }
  deleteList(key){
    delete this.tableData[key];
  }
  getListKeys(){
    let keys=[];
    for(let key in this.tableData){
      keys.push(key);
    }
    return keys;
  }
  getAllList(){
    let list=[];
    for(let key in this.getListKeys()){
      for(let item of this.tableData[key]){
        list.push(item);
      }
    }
    return list;
  }
  getTableData(){
    return this.tableData;
  }
  deleteAllKeys(){
    this.tableData={}
  }
  selected(that,key,target_list=[]){
    let list=this.getList(key);
    if(list&&list.length>0){
      let ch_md5s=list.map(item=>item.ch_md5);
      target_list.forEach(item=>{
        ch_md5s.includes(item.ch_md5)&&that.$refs.tableRef&&that.$refs.tableRef.toggleRowSelection(item);
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Admin/Butler/common/TableData.js